import { DrEntity } from './dr-entity';
import { RepresentationSet } from './corpus';
import { View } from './view';

export class WorkingSet extends DrEntity {
    name: string;
    description: string;
    createdOn: string;
    createdBy: string;
    representationSet: Array<RepresentationSet>;
    deletePending: boolean;
    workingSetView: View;

    // off-model display values
    documentCount: number;

    constructor(value?: Partial<WorkingSet>) {
        super(value);
        if (value) {
            if (value.workingSetView) {
                value.workingSetView = new View(value.workingSetView);
                value.documentCount = value.workingSetView.documentCount;
            }
            Object.assign(this, value);
        }
    }
}
